import { render } from "./IconSpinner.vue?vue&type=template&id=3347bc36"
import script from "./IconSpinner.vue?vue&type=script&lang=ts"
export * from "./IconSpinner.vue?vue&type=script&lang=ts"

import "./IconSpinner.vue?vue&type=style&index=0&id=3347bc36&lang=stylus"
script.render = render

export default script